import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';
import { applyDocumentTitle } from './brand';

// The server fills the title in for browsers and search engines; this covers `npm start`, where it does not.
applyDocumentTitle();

// The session cookie is httpOnly; the browser only attaches it when asked.
axios.defaults.withCredentials = true;

// The clock this browser is on, so the server can read a time the way the user
// meant it. The calendar screen resolves its own offsets before sending, but
// Rori does not: a time typed or spoken to the assistant arrives as a
// wall-clock string, and only this says whose wall it is. Sent as a header so
// every request carries it, which also lets the voice webhook — which reaches
// the server from ElevenLabs, not from here — use the last zone reported.
try {
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (zone) axios.defaults.headers.common['X-Time-Zone'] = zone;
} catch {
  // An environment without a resolvable zone falls back to UTC on the server.
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
